import React from 'react'
import { Dialog, DialogActions, DialogContent } from '@mui/material'

import { Button } from '../button'
import { color } from '../../theme'
import { observer } from 'mobx-react-lite'
import { ViewStyle } from 'react-native'

interface HourlyWarningProps {
  reject: () => void
  accept: () => void
  message: string
}
export const HourlyWarning = observer((props: HourlyWarningProps) => {
  const { accept, reject, message } = props
  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      open={true}
      sx={{
        '& .MuiPaper-root': {
          minWidth: '500px',
          minHeight: '500px',
        },
      }}
    >
      <DialogContent>
        <div style={BODY_TEXT_WRAPPER}>{message}</div>
      </DialogContent>
      <DialogActions style={DIALOG_BUTTON_CONTAINER}>
        <Button variant="outlined" size="small" color="error" onClick={reject} tx="Common.reject" />
        <Button size="small" onClick={accept} tx="Common.accept" />
      </DialogActions>
    </Dialog>
  )
})

const DIALOG_BUTTON_CONTAINER: React.CSSProperties = {
  display: 'flex',
  color: color.white,
  padding: 24,
}
const BODY_TEXT_WRAPPER: React.CSSProperties = {
  maxHeight: 500,
  paddingRight: 10,
  overflowY: 'auto',
  height: '100%',
  textAlign: 'left',
  fontSize: 15,
  letterSpacing: 0.3,
  padding: 24,
  paddingBottom: 0,
}
